
const DIRECTION_TYPE =
{
	RTL: 'rtl',
	LTR: 'ltr'
};


export default Object.freeze(DIRECTION_TYPE);
